import { ATTESTATIONS, GraduationServicePath, MONTHLY_INTERNSHIP } from "utils/constants";
import permissions from "app/permissions";
import CreateMonthlyInternshipAttestations from "./Create";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + MONTHLY_INTERNSHIP + "/students/" + ATTESTATIONS,
  title: "Добави заверка за месечен стаж",
  create: <CreateMonthlyInternshipAttestations />,
  permission: permissions.canManageMonthlyInternshipAttestations,
};
